import { MedicalPath } from "types/entity"
import { Action, ActionWithoutPayload, Message } from "types/redux"
import {
  CHECK_OPTIC_PATH,
  OPTIC_MESSAGE,
  SET_OPTIC_MEDICAL_PATH,
  OPTIC_CANCEL_PATH,
} from "./constants"

export interface CheckOpticPathPayload {
  // When true, the saga is allowed to send the patient to the start of the
  // survey when no answer exists yet. Leave false for background syncs such
  // as login, installation or profile updates so the patient stays on its
  // page. An ongoing optic path (ophthalmologist pending) always redirects
  // to payment regardless of this flag.
  redirect: boolean
}

const actions = {
  checkPath: (redirect = false): Action<CheckOpticPathPayload> => ({
    type: CHECK_OPTIC_PATH,
    payload: { redirect },
  }),
  cancelPath: (): ActionWithoutPayload => ({ type: OPTIC_CANCEL_PATH }),
  setPath: (payload: MedicalPath): Action<MedicalPath> => ({
    type: SET_OPTIC_MEDICAL_PATH,
    payload,
  }),
  inform: (payload: Message): Action<Message> => ({
    type: OPTIC_MESSAGE,
    payload,
  }),
}
export default actions
